/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  ListPinnedToolsParams,
  PaginatedPinnedTools,
  PinnedTool,
  PinnedToolRequestInput,
  SchemaValidationErrorResponse
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Creates a new pinned tool
 */
export const createPinnedTool = (
    pinnedToolRequestInput: MaybeRefOrGetter<PinnedToolRequestInput>,
 signal?: AbortSignal
) => {
      pinnedToolRequestInput = toValue(pinnedToolRequestInput);

      return axiosClient<PinnedTool>(
      {url: `/pinned_tools`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: pinnedToolRequestInput, signal
    },
      );
    }




export const getCreatePinnedToolMutationKey = () => ['createPinnedTool'] as const;

export const getCreatePinnedToolMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinnedTool>>, TError,CreatePinnedToolMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createPinnedTool>>, TError,CreatePinnedToolMutationVariables, TContext> => {

const mutationKey = getCreatePinnedToolMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPinnedTool>>, CreatePinnedToolMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPinnedTool(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePinnedToolMutationResult = NonNullable<Awaited<ReturnType<typeof createPinnedTool>>>
    export type CreatePinnedToolMutationBody = PinnedToolRequestInput
    export type CreatePinnedToolMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CreatePinnedToolMutationVariables = {data: PinnedToolRequestInput}

    /**
 * @summary Creates a new pinned tool
 */
export const useCreatePinnedTool = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPinnedTool>>, TError,CreatePinnedToolMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createPinnedTool>>,
        TError,
        CreatePinnedToolMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePinnedToolMutationOptions(options), queryClient);
    }
    /**
 * @summary List of pinned tools
 */
export const listPinnedTools = (
    params?: MaybeRefOrGetter<ListPinnedToolsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<PaginatedPinnedTools>(
      {url: `/pinned_tools`, method: 'GET',
        params, signal
    },
      );
    }




export const getListPinnedToolsQueryKey = (params?: MaybeRefOrGetter<ListPinnedToolsParams>,) => {
    return [
    'pinned_tools', ...(params ? [params] : [])
    ] as const;
    }


export const getListPinnedToolsQueryOptions = <TData = Awaited<ReturnType<typeof listPinnedTools>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(params?: MaybeRefOrGetter<ListPinnedToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPinnedTools>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListPinnedToolsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listPinnedTools>>> = ({ signal }) => listPinnedTools(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listPinnedTools>>, TError, TData>
}

export type ListPinnedToolsQueryResult = NonNullable<Awaited<ReturnType<typeof listPinnedTools>>>
export type ListPinnedToolsQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary List of pinned tools
 */

export function useListPinnedTools<TData = Awaited<ReturnType<typeof listPinnedTools>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 params?: MaybeRefOrGetter<ListPinnedToolsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listPinnedTools>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListPinnedToolsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Deletes a pinned tool
 */
export const deletePinnedTool = (
    namespace: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      namespace = toValue(namespace);

      return axiosClient<void>(
      {url: `/pinned_tools/${namespace}`, method: 'DELETE', signal
    },
      );
    }




export const getDeletePinnedToolMutationKey = () => ['deletePinnedTool'] as const;

export const getDeletePinnedToolMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinnedTool>>, TError,DeletePinnedToolMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deletePinnedTool>>, TError,DeletePinnedToolMutationVariables, TContext> => {

const mutationKey = getDeletePinnedToolMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePinnedTool>>, DeletePinnedToolMutationVariables> = (props) => {
          const {namespace} = props ?? {};

          return  deletePinnedTool(namespace,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePinnedToolMutationResult = NonNullable<Awaited<ReturnType<typeof deletePinnedTool>>>

    export type DeletePinnedToolMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeletePinnedToolMutationVariables = {namespace: string}

    /**
 * @summary Deletes a pinned tool
 */
export const useDeletePinnedTool = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePinnedTool>>, TError,DeletePinnedToolMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deletePinnedTool>>,
        TError,
        DeletePinnedToolMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePinnedToolMutationOptions(options), queryClient);
    }
